import { Modal, Form, Button, Col, Dropdown, Input, Layout, List, Menu, message, Row, Space, Select, Spin, Tooltip, FormInstance, ModalProps } from 'antd'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { ProFormInstance, ProFormText, ProFormTextArea, ProFormDigit, ProFormRadio, ModalForm } from '@ant-design/pro-form'

export type OrderDiscountRequest = {
  id: string;
  discountDollar: number;
  shippingDiscountDollar: number;
  comment: string;
};

export type OrderDiscountFormProps = {
  visible: boolean;
  onCancel: any;
  onSubmit: (values: OrderDiscountRequest) => Promise<void>;
  /** @name 弹框的标题 */
  title?: ModalProps['title'];
  width?: any;
  formValues?: any;
};

const OrderDiscountForm: React.FC<OrderDiscountFormProps> = (props) => {
  const formRef = useRef<ProFormInstance<any> | undefined>();
  const [newValue, setNewValue] = useState<any>({})
  return (
    <ModalForm title={props.title}
      grid={true}
      visible={props.visible}
      autoFocusFirstInput
      initialValues={props.formValues}
      modalProps={{
        destroyOnClose: true,
        onCancel: () => { props.onCancel(); },
      }}
      onFinish={async (values) => {
        props.onSubmit({ ...values })
      }}
      layout="horizontal"
      autoComplete="off"
      onValuesChange={(value, all) => { console.log(newValue); setNewValue({ ...newValue, ...all }); }}
      formRef={formRef} >
      <ProFormDigit name="discountDollar" label="商品降($)" colProps={{ md: 24 }} min={0} fieldProps={{ prefix: "$", precision: 2, controls: false }}></ProFormDigit>
      <ProFormDigit name="shippingDiscountDollar" label="运费降($)" colProps={{ md: 24 }} min={0} fieldProps={{ prefix: "$", precision: 2, controls: false }}></ProFormDigit>
      <ProFormTextArea name="comment" label="详情备注" colProps={{ md: 24 }} ></ProFormTextArea>
    </ModalForm>
  )

};
export default OrderDiscountForm
